import { SCHEDULE_APPOINTMENT, ITEM_APPOINTMENT_DETAILS } from 'actions/user';

export default (state = null, action) => {
    switch (action.type) {
        case SCHEDULE_APPOINTMENT:
            if (!!action.error) {
                return action.payload;
            } else {
                return action.payload.data;
            }
        case ITEM_APPOINTMENT_DETAILS:
            return action.payload;
    }

    return state;
}